import script from "./aboutPop.vue?vue&type=script&setup=true&lang=js"
export * from "./aboutPop.vue?vue&type=script&setup=true&lang=js"

import "./aboutPop.vue?vue&type=style&index=0&id=2ac6e0d8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ac6e0d8"]])

export default __exports__